import ComponentWithSocket from '../../../lib/component';
import { Component } from 'vue-property-decorator';

import * as Store from '../../../store';

@Component
export default class UsersList extends ComponentWithSocket {
    public data: { users: any[]; server: any } = {
        users: [],
        server: undefined,
    };

    rejectReason: string = '';
    selectedVerification?: any;

    constructor() {
        super();

        this.wsListener.onGet(
            'admin.statistics.live',
            (success: boolean, data: any) => {
                Store.commitLoaderVisibility(this.$store, false);

                if (success) {
                    this.data.users = data.users;
                    this.data.server = data.server;
                }

                setTimeout(() => {
                    this.wsListener.sendGet('admin.statistics.live');
                }, 1000);
            },
        );
    }

    beforeRouteLeave(to: any, from: any, next: any) {
        this._beforeLeave(to, from);
        next();
    }

    mounted() {
        Store.commitLoaderVisibility(this.$store, true);

        this.wsListener.sendGet('admin.statistics.live');
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/statistics/live/index.ts